import React, { useState } from 'react';
import '../styles/Project.css';
import { Link } from 'react-router-dom';

const Project = () => {
  const [filter, setFilter] = useState('');

  // Sample projects data
  const projects = [
    {
      id: 1,
      title: "Flexible Sheet for Robotic Perception",
      authors: "Arulsham Bhasin, Deepesh Patidar, Manoj Kumar Yadav, Dr Vijay Kumar Pal",
      subtitle: "Associated with MSME Lab at IIT Jammu",
      date: "June 2024",
      year: "2024",
      category: "",
      image:  require('../assets/projects/sensor.png') ,
      route: "/projects/flexible-sensing-sheet"
    },
    // {
    //   id: 2,
    //   title: "Snake Robot",
    //   authors: "Arulsham Bhasin, Arsh Shaunak, Anant Khosla",
    //   subtitle: "Personal Project",
    //   date: "Dec 2024",
    //   year: "2024",
    //   category: "",
    //   image:  require('../assets/projects/snaek.png'),
    //   route: "/projects/snake-robot"
    // },
    {
      id: 3,
      title: "Drones (Micro Class, Quadcopters)",
      authors: "Arulsham Bhasin and Various Teams",
      subtitle: "Personal and Associated with SAE UIET PU",
      date: "Mar 2022",
      year: "2023",
      category: "",
      image: require('../assets/projects/quad.jpg'),
      route: "/projects/quadcopters"
    },
    {
      id: 4,
      title: "Drones (Micro Class, Fixed Wing)",
      authors: "Arulsham Bhasin, Vinayak Sharma, Sakasham Rathore, Sahil, Mohit ",
      subtitle: "Associated with SAE UIET PU",
      date: "Feb 2023",
      year: "2023",
      category: "",
      image: require('../assets/projects/plane.jpg'),
      route:"/projects/fixed-wing"
    },
    {
      id: 5,
      title: "Robowars Bots",
      authors: "Arulsham Bhasin and various teams",
      subtitle: "Associated with SAE UIET PU",
      date: "Sept 2024",
      year: "2024",
      category: "",
      image: require('../assets/projects/robowar.jpg'),
      route: "/projects/robowar-bots"
    },
    {
      id: 6,
      title: "Motion Sensing Glove",
      authors: "Ujjwal Raj, Arulsham Bhasin, Tanish Raina, Vivek Yadav, Ashish Sharma, Ketan Jain, Dr Mamta Juneja",
      subtitle: "Associated with DIC MDart at Panjab University",
      date: "Mar 2022",
      year: "2022",
      category: "",
      image: require('../assets/projects/glove.jpg'),
      route: "/projects/motion-sensing-glove"
    },
    {
      id: 7,
      title: "GoKart(125ccEngine,Petrol)",
      authors: "Arsh Shaunak, Arulsham Bhasin and others",
      subtitle: "Associated with SAE UIET PU",
      date: "Oct 2023",
      year: "2023",
      category: "",
      image: require('../assets/projects/gokart.jpg'),
      route: "/projects/go-kart"
    },
    {
      id: 8,
      title: "Flexible Strain Sensors",
      authors: "Arulsham Bhasin, Deepesh Patidar, Manoj Kumar Yadav, Dr Vijay Kumar Pal",
      subtitle: "Associated with MSME Lab at IIT Jammu",
      date: "Dec 2023",
      year: "2023",
      category: "",
      image: require('../assets/projects/str.jpg'),
      route: "/projects/flexible-strain-sensors"
    },
     {
      id: 9,
      title: "  Line Follower",
      authors: "Arulsham Bhasin",
      subtitle: "Personal Project",
      date: "June 2020",
      year: "2020",
      category: "",
      image: require('../assets/projects/lf.jpg'),
      route: "/projects/line-follower"
    },
     {
      id: 10,
      title: " Mobile Robots",
      authors: "Arulsham Bhasin",
      subtitle: "Personal Project",
      date: "Dec 2022",
      year: "2022",
      category: "",
      image: require('../assets/projects/mobile.jpg'),
      route: "/defaults/update-soon"
    },
    //     {
    //   id: 11,
    //   title: "Drone (Nano Class, Quad)",
    //   authors: "Arulsham Bhasin, Arsh Shaunak",
    //   subtitle: "Personal Project",
    //   date: "Jan 2025",
    //   year: "2025",
    //   category: "",
    //   image: require('../assets/coming-soon.jpg'),
    //   route: "/defaults/update-soon"
    // },
   {
      id: 12,
      title: " Sugar Rocket",
      authors: "Arulsham Bhasin, Arsh Shaunak",
      subtitle: "Personal Project",
      date: "June 2025",
      year: "2025",
      category: "",
      image: require('../assets/projects/candyman.jpg'),
      route: "/projects/rocket-candy"
    },
      {
      id: 12,
      title: "Jaw Grippers",
      authors: "Arulsham Bhasin, Parth Joshi, Abhinab",
      subtitle: "Associated with Robotics Lab at IIT Gandhinagar",
      date: "Jan 2025",
      year: "2025",
      category: "",
      image: require('../assets/projects/iitgn/g1.png'),
      route: "/projects/jaw-grippers"
    },
       {
      id: 13,
      title: "Motor Casing for Continuum Manipulator",
      authors: "Arulsham Bhasin, Basharat Shafi",
      subtitle: "Associated with Robotics Lab at IIT Gandhinagar",
      date: "Jan 2025",
      year: "2025",
      category: "",
      image: require('../assets/projects/iitgn/cr1.png'),
      route: "/projects/motor-casing-continuum"
    },
    {
      id: 14,
      title: "Leg Unit for Quadruped Robot",
      authors: "Arulsham Bhasin, Vignesh",
      subtitle: "Associated with Robotics Lab at IIT Gandhinagar",
      date: "Jan 2025",
      year: "2025",
      category: "",
      image: require('../assets/projects/iitgn/Leg.PNG'),
      route: "/projects/quadruped-leg"
    },
    //        {
    //   id: 11,
    //   title: "Timepiece (Digital Pocket Watch)",
    //   authors: "Arulsham Bhasin",
    //   subtitle: "Personal Project",
    //   date: "June 2025",
    //   year: "2022",
    //   category: "",
    //   image: require('../assets/placeholder.png'),
    //   route: "/defaults/update-soon"
    // },
           {
      id: 11,
      title: "RC Boat",
      authors: "Arulsham Bhasin",
      subtitle: "Personal Project",
      date: "June 2021",
      year: "2021",
      category: "",
      image: require('../assets/projects/boat2.png'),
      route: "/defaults/update-soon"
    },
    // {
    //   id: 11,
    //   title: " Nano Drone Swarm",
    //   authors: "Arulsham Bhasin, Arsh Shaunak",
    //   subtitle: "What Up",
    //   date: "June 2025",
    //   year: "2025",
    //   category: "",
    //   image: "",
    //   route: "/defaults/update-soon"
    // }
  ];

  const filteredProjects = projects.filter(project =>
    project.title.toLowerCase().includes(filter.toLowerCase()) ||
    project.authors.toLowerCase().includes(filter.toLowerCase())
  );

  const groupedByYear = filteredProjects.reduce((acc, project) => {
    if (!acc[project.year]) {
      acc[project.year] = [];
    }
    acc[project.year].push(project);
    return acc;
  }, {});

  return (
    <div className="project-container">
      <div className="project-content">
        {/* Header */}
        <div className="project-header">
          <h1 className="project-title">Projects</h1>
          <p className="project-subtitle">
           Note: I am making some changes to the website and you might have to refesh some pages once or twice
           </p>
          <p>
           Prototypes I built for Pacific Labs and other Products of commercial nature are not included. I have also not included some of personal stuff and projects against courses at PU. 
          </p>
        </div>

        {/* Filter Input */}
        {/* <div className="filter-container">
          <input
            type="text"
            placeholder="Type to filter"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            className="filter-input"
          />
        </div> */}

        {/* Projects by Year */}
        {Object.keys(groupedByYear)
          .sort((a, b) => b - a)
          .map(year => (
            <div key={year} className="year-section">
              {/* Year Header */}
              <div className="year-header">
                <h2 className="year-title">{year}</h2>
                <br />
                <hr className='divider' />
              </div>

              {/* Simple Project Cards */}
              <div className="simple-projects-container">
                {groupedByYear[year].map(project => (
                  <Link key={project.id} className="no-underline" to={project.route}>
                    <div className="simple-project-card">
                      {/* Project Image */}
                      <div className="simple-project-image">
                        <img className="simple-image-placeholder" src={project.image} />

                      </div>

                      {/* Project Info */}
                      <div className="simple-project-info">
                        <h3 className="simple-project-title">
                          {project.title}
                        </h3>
                        <h5 className="simple-project-authors">
                          {project.subtitle}
                        </h5>
                        <p className="simple-project-authors">
                          {project.authors}
                        </p>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          ))}

        {filteredProjects.length === 0 && (
          <div className="no-results">
            <p className="no-results-text"></p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Project;